"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContext = void 0;
const react_1 = require("react");
exports.AdminContext = (0, react_1.createContext)({
    reindexUrl: '',
    soapMessagesUrl: '',
});
//# sourceMappingURL=admin-context.js.map